import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getApplicationFees = async (): Promise<number> => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getApplicationFees.url, null))
    .get<number>()
}

export const getFamilyDiscount = async (): Promise<number> => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getFamilyDiscount.url, null))
    .get<number>()
}
